import { render } from "./QuestionsPage.vue?vue&type=template&id=4c8d24a4"
import script from "./QuestionsPage.vue?vue&type=script&lang=js"
export * from "./QuestionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__